<mat-select
  [multiple]="multiple"
  [panelClass]="panelClass"
  [disabled]="disabled"
  [compareWith]="boundCompareFn"
  [value]="value"
  (valueChange)="onSelectChange($event)"
>
  <!-- <mat-select-trigger>
    {{currentItem?.text}}
  </mat-select-trigger> -->
  <mat-option *ngFor="let item of items" [value]="item.value">
    <ng-container
      *ngIf="template; else noTemplate"
      [ngTemplateOutlet]="template"
      [ngTemplateOutletContext]="{ $implicit: item }"
    ></ng-container>

    <ng-template #noTemplate>{{ item.text }}</ng-template>
  </mat-option>
</mat-select>
<mat-progress-bar
  *ngIf="isLoading"
  color="accent"
  mode="indeterminate"
></mat-progress-bar>
